var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{directives:[{name:"show",rawName:"v-show",value:(_vm.iframe.loaded),expression:"iframe.loaded"}],ref:"payment",attrs:{"src":_vm.iframe.src,"frameborder":"0","height":"1200"},on:{"load":_vm.load}})
}
var staticRenderFns = []

export { render, staticRenderFns }